import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { QualityControlMechanical, RepositoryModal } from '../../../shared'
import { MechanicalComponent } from './mechanical.component'

@Component({
    templateUrl: './mechanical-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class MechanicalModalComponent extends RepositoryModal<QualityControlMechanical> implements OnInit {
    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as MechanicalComponent

        if (this.isAdding) {
            this.target.job = parentComponent.selectedJob()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }
        return true
    }
}
